import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Button from "../common/button/button";
import { Controller, useForm } from "react-hook-form";
import Group13 from "../common/assets/group13.svg";
import LabelWithHR from "../common/label/labelWithHR";
import ModalHeader from "../common/modal/modalHeader";
import {
  getModalStyleWithoutRedBackground,
} from "../reusable/functions";
import Style from "./modalLicensePlate.module.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { startsWithLetter } from "../reusable/licensePlateValidation";

// Warning View Component
const WarningView = ({ licensePlate, onEdit, onProceed }) => {
  const { t } = useTranslation();

  return (
    <div className={Style.form}>
      <div className={Style.warningContainer}>
        <div className={Style.warningMessage}>
          <p className={Style.warningText}>
            {t("RegisterVisitor.LicensePlateWarning.Message", { plate: licensePlate })}
          </p>
          <p className={Style.warningQuestion}>
            {t("RegisterVisitor.LicensePlateWarning.Question")}
          </p>
        </div>
      </div>

      <div className={Style.buttonGroup}>
        <Button
          text={t("RegisterVisitor.LicensePlateWarning.EditButton")}
          buttonStyle={{ marginBottom: "10px", backgroundColor: "#6c757d" }}
          onClick={onEdit}
        />
        <Button
          text={t("RegisterVisitor.LicensePlateWarning.ProceedButton")}
          buttonStyle={{ marginBottom: "20px" }}
          onClick={onProceed}
        />
      </div>
    </div>
  );
};

// Input View Component
const InputView = ({ licensePlateInputValue, setLicensePlateInputValue, onSubmit, handleSubmit, control }) => {
  const { t } = useTranslation();

  return (
    <form className={Style.form} onSubmit={handleSubmit(onSubmit)}>
      <LabelWithHR label={t("UserHome.License plate")} />
      <Controller
        name="licensePlateInputValue"
        control={control}
        render={() => (
          <div className={Style.licensePlateOuter}>
            <div className={Style.licensePlateMid}>
              <div className={Style.licensePlateInner}>
                <input
                  type={"text"}
                  autoComplete="on"
                  id="license-plate"
                  name="license-plate"
                  autoCapitalize="characters"
                  className={`${Style.inputMask} ${Style.inputMaskText}`}
                  value={licensePlateInputValue.toUpperCase()}
                  onChange={(e) => {
                    if (e.target.value.includes(" ")) {
                      return;
                    }
                    setLicensePlateInputValue(
                      e.target.value.trim().toUpperCase()
                    );
                  }}
                />
              </div>
            </div>
          </div>
        )}
      />

      <Button
        text={t("Global.continue")}
        buttonStyle={{ marginBottom: "20px" }}
        disabled={!licensePlateInputValue}
      />
    </form>
  );
};

const ModalLicensePlate = (props) => {
  const { handleSubmit, control } = useForm();
  const { t } = useTranslation();

  const [licensePlateInputValue, setLicensePlateInputValue] = useState(props.defaultValue || "");
  const [showWarning, setShowWarning] = useState(false);

  const setLicensePlate = () => {
    // Check if license plate format is invalid
    if (!startsWithLetter(licensePlateInputValue)) {
      setShowWarning(true);
      return; // Don't close modal yet, show warning instead
    }
    // Valid format or user confirmed to proceed
    proceedWithLicensePlate();
  };

  const proceedWithLicensePlate = () => {
    props.setLicensePlate(licensePlateInputValue);
    props.close();
  };

  const handleEdit = () => {
    setShowWarning(false); // Return to input view
  };

  return (
    <Modal
      open={props.open}
      closeOnEs={true}
      onClose={props.close}
      center
      styles={getModalStyleWithoutRedBackground()}
    >
      <ModalHeader
        textLabel={showWarning ? t("RegisterVisitor.LicensePlateWarning.Title") : t("Global.enter")}
        src={Group13}
      />

      {showWarning ? (
        <WarningView
          licensePlate={licensePlateInputValue}
          onEdit={handleEdit}
          onProceed={proceedWithLicensePlate}
        />
      ) : (
        <InputView
          licensePlateInputValue={licensePlateInputValue}
          setLicensePlateInputValue={setLicensePlateInputValue}
          onSubmit={setLicensePlate}
          handleSubmit={handleSubmit}
          control={control}
        />
      )}
    </Modal>
  );
};
export default ModalLicensePlate;
